import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/api';

// Favoris par défaut tant que l'utilisateur n'a rien personnalisé.
export const DEFAULT_FAVORIS = ['/planning', '/commandes', '/finance', '/stocks'];

/** Favoris du menu personnalisables par compte (ajout/retrait via l'étoile), persistés en BDD. */
export const useMenuFavoris = (user) => {
  const [favoris, setFavoris] = useState(null); // null = en cours de chargement

  useEffect(() => {
    if (!user) return undefined;
    let cancelled = false;
    axios.get(`${getApiUrl()}/menu-favoris`, { withCredentials: true })
      .then((r) => { if (!cancelled) setFavoris(Array.isArray(r.data?.favoris) ? r.data.favoris : DEFAULT_FAVORIS); })
      .catch(() => { if (!cancelled) setFavoris(DEFAULT_FAVORIS); });
    return () => { cancelled = true; };
  }, [user]);

  const list = favoris === null ? DEFAULT_FAVORIS : favoris;
  const favSet = new Set(list);

  const toggleFav = useCallback((path) => {
    if (!path) return;
    setFavoris((prev) => {
      const base = prev === null ? DEFAULT_FAVORIS : prev;
      const next = base.includes(path) ? base.filter((p) => p !== path) : [...base, path].slice(0, 12);
      axios.put(`${getApiUrl()}/menu-favoris`, { favoris: next }, { withCredentials: true }).catch(() => {});
      return next;
    });
  }, []);

  return { favoris: list, favSet, toggleFav };
};
